<template>
  <el-container>
    <!-- 头部 -->
    <headerPage></headerPage>

    <!-- 轮播图 -->
    <div class="carousel-wrapper">
      <el-carousel :interval="4000" arrow="always" height="70vh">
        <el-carousel-item v-for="(url, index) in imageUrls" :key="index">
          <img :src="url" class="carousel-image" alt="carousel">
        </el-carousel-item>
      </el-carousel>
    </div>

    <!-- 选课中心标题 -->
    <div class="course-selection-title">
      <h2>推荐课程</h2>
    </div>

    <!-- 课程推荐部分 -->
    <el-main style="margin: 0 200px">
      <el-row :gutter="20" style="row-gap: 20px">
        <el-col
            :span="8"
            v-for="(course, index) in courses"
            :key="course.id"
            style="margin-bottom: 20px"
        >
          <div class="grid-content bg-purple course-card" style="display: flex; flex-direction: column; align-items: center;">
            <!-- 图片部分 -->
            <div class="top-section" style="width: 100%; height: 180px; margin-bottom: 20px; overflow: hidden;">
              <img :src="course.courseImg"
                   style="width: 100%; height: 100%; object-fit: contain"
                   :alt="course.courseName">
            </div>
            <!-- 标题和价格部分 -->
            <div class="bottom-section" style="width: 100%; padding: 0 15px; text-align: center;">
              <h4 style="margin: 10px 0">{{ course.courseName }}</h4>
              <div style="display: flex; justify-content: center; align-items: center; gap: 10px;">
                <span style="color: #666;">精品课程</span>
                <span style="color: #e60012; font-weight: bold;">{{ course.coursePrice }}</span>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <!-- 分页控件 -->
      <!--      <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNo" :limit.sync="queryParams.pageSize"-->
      <!--                  @pagination="getList" />-->
    </el-main>

    <!-- 网校动态 -->
    <div class="course-selection-title">
      <h2>网校动态</h2>
    </div>
    <el-main style="margin: 0 200px">
      <el-row :gutter="20">
        <el-col :span="24">
          <div class="news-card announcement">
            <ul class="announcement-list">
              <li v-for="announcement in announcements" :key="announcement.id" class="announcement-item">
                <div class="announcement-content">
                <span :class="getLabelClass(announcement.type)">
                  {{ getTypeText(announcement.type) }}
                </span>
                  <span class="announcement-title" @click="goToDetail(announcement.id)">
                  {{ announcement.title }}
                </span>
                  <span class="announcement-date">{{ formatDate(announcement.createTime) }}</span>
                </div>
              </li>
            </ul>
          </div>
          <el-pagination
              v-show="total > 0"
              :current-page="queryParams.pageNo"
              :page-size="queryParams.pageSize"
              layout="total, prev, pager, next"
              :total="total"
              @current-change="handlePageChange">
          </el-pagination>
        </el-col>
      </el-row>
    </el-main>
    <!-- 页脚 -->
    <el-footer style="background-color: #f1eded; color: #ffffff; text-align: center; height: 1px; border-top: 1px solid #ccc;">
    </el-footer>
    <bottomPage></bottomPage>
  </el-container>
</template>

<script>
import headerPage from "@/components/header/header";
import bottomPage from "@/components/bottom/bottom"
import {gitCourseList, gitNoticeList} from "@/api";
import moment from 'moment';

export default {
  components: {
    headerPage,
    bottomPage
  },
  data() {
    return {
      announcements: [],
      courses: [],
      total: 0, // 总记录数
      queryParams: {
        pageNo: 1,
        pageSize: 10,
      },
      isLoggedIn: false, // 判断是否登录
      userInfo: {
        avatar: '', // 用户头像
        username: '' // 用户名
      },
      imageUrls: [
        // 'https://sce9a1b1c5d96u-sb-qn.qiqiuyun.net/files/system/2021/03-06/23205357b367039848.jpg ',
        // 'https://sce9a1b1c5d96u-sb-qn.qiqiuyun.net/files/system/2021/03-06/23365354a670617138.jpg ',
        'https://sce9a1b1c5d96u-sb-qn.qiqiuyun.net/files/system/2021/03-06/23332337db78985982.jpg '
      ],
    };
  },
  created() {
    this.getList();
    this.gitNoticeList();
  },
  methods: {
    async getList() {
      try {
        // 获取精品课程
        const response = await gitCourseList(this.queryParams);
        this.courses = response.data.list.map(course => {
          return {
            id: course.id,
            courseName: course.courseName,
            courseImg: course.courseImg,
            coursePrice: course.coursePrice
          };
        });
        this.total = response.data.total;
      } catch (error) {
        console.error('获取课程列表失败:', error);
      }
    },
    async gitNoticeList(){
      try {
        const response = await gitNoticeList(this.queryParams);
        this.announcements = response.data.list.map(course => {
          return {
            id: course.id,
            title: course.title,
            date: course.createTime,
            type: course. type
          };
        });
        this.total = response.data.total;
      } catch (error) {
        console.error('获取公告列表失败:', error);
      }
    },
    handlePageChange(pageNo) {
      this.queryParams.pageNo = pageNo;
      this.gitNoticeList();
    },
    goToLogin() {
      this.$router.push('/login');
    },
    goToDetail(id) {
      this.$router.push({
        name: "announcementDetail",
        params: {
          id: id,
        },
      });
    },
    getTypeText(type) {
      return type === 1 ? '公告：' : '通知：';
    },
    getLabelClass(type) {
      return type === 1 ? 'announcement-announcement' : 'announcement-notice';
    },
    formatDate(timestamp) {
      return moment(timestamp).format('YYYY-MM-DD');
    }
  }
};
</script>

<style scoped>
.carousel-wrapper {
  margin-top: 0;
  overflow: hidden;
}

.carousel-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.course-selection-title {
  text-align: center;
  margin-top: 20px;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
  height: auto;
  overflow: hidden;
}

.course-card {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer;
}

.course-card:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.top-section img {
  transition: transform 0.3s ease;
}

.course-card:hover .top-section img {
  transform: scale(1.05);
}

/*公告模块*/
.news-card {
  margin-bottom: 20px;
  width: 100%;
}
.announcement-list {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.announcement-item {
  border-bottom: 1px solid #ebeef5;
  padding: 8px;
  display: flex;
  align-items: center;
  transition: background-color 0.3s;
}
.announcement-item:hover {
  background-color: #f5f7fa;
}
.announcement-content {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.announcement-label {
  display: inline-block;
  margin-right: 8px;
  padding: 2px 8px;
  border-radius: 12px;
  font-weight: bold;
  line-height: 1;
}
.announcement-notice {
  color: #e60012;
}
.announcement-announcement {
  color: #409EFF;
}
.announcement-title {
  flex: 1;
  margin-right: 8px;
}
.announcement-date {
  max-height: 15px; /* 最大高度为 30px */
}
.el-footer {
  background-color: #B3C0D1;
  color: #333;
  text-align: center;
  line-height: 60px;
}
</style>
